import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useAddresses } from 'contexts/Addresses';
import { DeliveryAddressField } from 'fields';
import { useField } from 'formik';

export default function DeliveryAddress({ customerReference }: { customerReference: string }) {
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'CustomerDetails' });

  const [, , { setValue }] = useField('addressData');
  const [{ value: transportMethod }] = useField('transportMethod');

  const {
    state,
    selectors: { selectAddress },
  } = useAddresses();

  const onAddressChange = useCallback(
    async (value: number | string) => {
      const addressData = selectAddress(state, +value);
      if (addressData) {
        await setValue({
          addressNumber: addressData.addressNumber,
          addressName: addressData.addressName,
          addressStreet: addressData.addressStreet,
          postcodeArea: addressData.postcodeArea,
          postcodeDistrict: addressData.postcodeDistrict,
          movementRestriction: addressData.movementRestriction,
        });
      }
    },
    [selectAddress, setValue, state],
  );

  return (
    <DeliveryAddressField
      required
      name="addressNumber"
      label={t(`labels.deliveryAddress${transportMethod}`)}
      placeholder={t('placeholders.deliveryAddress')}
      noOptionsFoundText={t('labels.noAddressesFound')}
      customerReference={customerReference}
      onChange={onAddressChange}
      transportMethod={transportMethod}
    />
  );
}
